import SportsRounded from "@mui/icons-material/SportsRounded";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@bw/shared/hooks";
import { NavRow } from "../../../common/components/NavRow";
import { experienceApi } from "../experienceApi";

/** App-injected Account shortcut; only the owning module reads claim authority. */
export function CoachingExperienceAccountLink() {
  const { user } = useAuth();
  if (!user) return null;
  return <CoachingExperienceAccountLinkBody key={user.uid} userId={user.uid} />;
}

function CoachingExperienceAccountLinkBody({ userId }: { userId: string }) {
  const access = useQuery({
    queryKey: ["coach-experience", "access", userId],
    queryFn: experienceApi.access,
    retry: false,
    staleTime: 0,
    refetchOnMount: "always",
  });
  const current =
    access.isSuccess &&
    access.isFetchedAfterMount &&
    access.fetchStatus === "idle" &&
    access.error === null;
  if (!current || !access.data.can_access) return null;
  return (
    <NavRow icon={<SportsRounded />} label="Coaching experience" to="/me/coaching-experience" />
  );
}
